namespace Portico.Filters {

	angular.module('app').filter('highlight', ['$sce', ($sce: angular.ISCEService) => {
		return (text: string, phrase: string) => {
			let t = text;

			if (t) {
				if (phrase) {
					let p = phrase.replace(/([\\.*+?^$|(){}\[\]])/g, '\\$1');
					t = t.replace(new RegExp('(' + p + ')', 'gi'), '$$$$$$HIGHLIGHT$$$$$$');
					phrase = phrase.replace(/</g, '&lt;').replace(/>/g, '&gt;');
				}

				t = t.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\$\$\$HIGHLIGHT\$\$\$/g, '<span class="highlighted">' + phrase + '</span>');
			}

			return $sce.trustAsHtml(t);
		}
	}]);
}
